import { mdiBookAccountOutline } from '@mdi/js'

export default {
  title: 'E-Raport',
  to: 'eraport-school',
  icon: mdiBookAccountOutline,
  action: 'read',
  resource: 'EraportSchool',
}
